/*
 * @Descripttion:
 * @Author: chenxt
 * @Date: 2024-12-06 15:52:01
 */
// 一些全局的config配置
const modeUrlObj = {
  // 线上环境
  production: {
    // baseURL: 'http://192.168.4.246:9083',
    // questUrl: 'http://192.168.4.246:9083/dcwj/#/questionnairePreview',
    baseURL: 'https://xjjgjc.org.cn', //正式环境
    questUrl: 'https://xjjgjc.org.cn/dcwj/#/questionnairePreview', //正式环境
    devProxy: '' + '/prod-api',
    devProxy2: '' + '/wxLoginApi',
    vueConfigPublicPath: '/#',
    authBaseURL: ''
  },
  // 开发环境
  development: {
    baseURL: 'http://192.168.4.246:9073',
    // questUrl: 'http://192.168.4.246:9075/jgjc/dcwj/questionnairePreviewUser.jsp',
    questUrl: 'http://192.168.4.246:9073/dcwj/#/questionnairePreview',
    devProxy: '' + '/dev-api',
    devProxy2: '' + '/dev-api',
    vueConfigPublicPath: '/#',
    authBaseURL: ''
  },
  // 测试环境
  test: {
    baseURL: 'http://XXXX:9091/test/',
    authBaseURL: ''
  }
};
export default modeUrlObj[process.env.NODE_ENV]
